import React, { Component, PropTypes } from 'react'

import { getProperty, filterObject } from '../utils'
import { Loading } from '../misc'
import { Boolean } from '../ui'

export default class OwnLighting extends Component {
    static propTypes = {
        crewType: PropTypes.string.isRequired,
        crew_uuid: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
    }

    _updateValueAndSendPatchRequest = (data) => {
        this.props.updateValue(data)
        this._sendPatchRequest(data)
    }

    _sendPatchRequest = (data = this.props.data) => {
        const newData = filterObject(
            data,
            [ 'gaffer_own_lighting' ],
        )

        this.props.gearActions.patchGear(newData, this.props.crew_uuid, this.props.crewType)
    }

    render() {
        if (! this.props.data) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Professional Equipment
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        <Boolean
                            error={ errors.gaffer_own_lighting }
                            label="Do you own lighting & grip equipment?"
                            name="gaffer_own_lighting"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'gaffer_own_lighting') }
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/own_lighting.js